import { useState } from 'react';
import type { FormEvent } from 'react';
import { useSesion } from '../estado/SesionContext';

export function Login() {
  const { entrar, espacio } = useSesion();
  const [documento, setDocumento] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function alEnviar(evento: FormEvent) {
    evento.preventDefault();
    setError('');
    setEnviando(true);
    try {
      await entrar(documento, clave);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'No se pudo ingresar. Intenta de nuevo.');
    } finally {
      // SIEMPRE, incluso si falla: un `disabled` que no se revierte deja al usuario
      // mirando una pantalla muerta sin saber qué pasó.
      setEnviando(false);
    }
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-sm flex-col justify-center px-5 py-10">
      <div className="mb-8 text-center">
        <img src={espacio.logoUrl} alt={espacio.cliente} className="mx-auto h-16 w-auto" />
        <h1 className="mt-4 font-titulos text-2xl font-extrabold text-azul">{espacio.nombre}</h1>
        <p className="mt-1 text-sm text-gris">Capacitación para impulsadores</p>
      </div>

      <form onSubmit={alEnviar} noValidate>
        <label htmlFor="documento" className="mb-1 block text-sm font-extrabold">
          Documento
        </label>
        <input
          id="documento"
          value={documento}
          onChange={(e) => setDocumento(e.target.value)}
          inputMode="numeric"
          maxLength={12}
          autoComplete="username"
          autoCapitalize="off"
          className="mb-4 w-full rounded-xl border border-borde bg-white px-4 py-3 text-base outline-none focus:border-azul"
          placeholder="Tu DNI"
        />

        <label htmlFor="clave" className="mb-1 block text-sm font-extrabold">
          Clave
        </label>
        <input
          id="clave"
          type="password"
          value={clave}
          onChange={(e) => setClave(e.target.value)}
          autoComplete="current-password"
          className="mb-4 w-full rounded-xl border border-borde bg-white px-4 py-3 text-base outline-none focus:border-azul"
          placeholder="••••••"
        />

        {error && (
          <p role="alert" className="mb-3 rounded-lg bg-rojo/10 px-3 py-2 text-sm text-rojo">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={enviando}
          className="w-full rounded-full bg-rojo py-3.5 text-base font-extrabold text-white transition hover:bg-rojo-osc disabled:opacity-60"
        >
          {enviando ? 'Ingresando…' : 'Ingresar'}
        </button>
      </form>

      <p className="mt-5 text-center text-xs leading-relaxed text-gris">
        Es el mismo documento y la misma clave con la que marcas tu asistencia.
        <br />
        Si no puedes entrar, avisa a tu coordinador.
      </p>
    </main>
  );
}
